import React, { FC } from 'react'
import { Col } from 'styled-bootstrap-grid'

import { Switch } from 'mf-ui-components'

import {
  StyledRow,
  SwitchLabelContainer,
  SwitchLabel,
} from './InvestmentTypeControl.styles'
import rawlang, * as l10n from '../../../../utils/l10n'
import ESGLeafSVG from '../../../../images/esg-leaf.svg'
import { InvestmentStyle } from '../../../../types/ModelPortfolio'

const lang = rawlang as 'it' | 'en'

type Props = {
  investmentStyle: InvestmentStyle
  handleChange: () => void
}

export const InvestmentTypeControl: FC<Props> = ({
  investmentStyle,
  handleChange,
}) => (
  <div style={{ marginBottom: '48px' }}>
    <StyledRow>
      <SwitchLabelContainer>
        <img src={ESGLeafSVG} aria-hidden />
        <SwitchLabel>{l10n.esg_option[lang]}</SwitchLabel>
      </SwitchLabelContainer>
      <Switch checked={investmentStyle === 'esg'} onChange={handleChange} />
    </StyledRow>
  </div>
)
